import SettingsProfile from '@/components/settings/pages/SettingsProfile';

const PropertySettings = () => <SettingsProfile />;

export const Route = createFileRoute({
	component: PropertySettings,
});
